import axiosInstance from './axiosInstance';

/**
 * Получить список баз данных, к которым текущий пользователь имеет доступ.
 * Этот эндпоинт предназначен для обычных пользователей (без admin token).
 */
export const fetchMyDatabases = async (): Promise<any[]> => {
  const { data } = await axiosInstance.get('/database-access/me');
  return data;
};
